import { OverlayRef } from '@angular/cdk/overlay';
import {
  Subject, Observable, take, tap, Subscription
} from 'rxjs';
import { filter, mergeWith } from 'rxjs/operators';

import { IIrisModalConfig } from './modal-config.interface';
import { IrisModalContent } from './modal-content.type';

/**
 * A reference to the modal itself.
 * Can be injected into the component added to the overlay and then used to close itself.
 */
export class IrisModalRef<TContent, TModalInputs, TResponseData> {
  private afterClosedSubject = new Subject<TResponseData>();
  private backdropClickOrDetachSubscription: Subscription;

  constructor(
    private overlayRef: OverlayRef,
    public content: IrisModalContent<TContent>,
    public config: IIrisModalConfig<TModalInputs> // pass config to modal component
  ) {
    this.backdropClickOrDetachSubscription = overlayRef
      .backdropClick()
      .pipe(
        mergeWith(overlayRef.detachments().pipe(
          filter(() => overlayRef.hasAttached())
        )),
        take(1),
        tap(() => this.close())
      ).subscribe();
  }

  /**
   * Closes the overlay. You can optionally provide a result.
   */
  close(result?: TResponseData): void {
    // TODO: prevent close if modal element contains unsaved data (PE-26164)
    this.overlayRef.dispose();
    this.backdropClickOrDetachSubscription.unsubscribe();
    this.afterClosedSubject.next(result);
    this.afterClosedSubject.complete();
  }

  /**
   * An Observable that notifies when the overlay has closed
   */
  afterClosed$(): Observable<TResponseData> {
    return this.afterClosedSubject.asObservable();
  }
}
